import React from 'react';
import Utils from '../../providers/Utils';
import SpecificComponent from '../SpecificComponent';
import avatar from '../../Pics/avatar.jpg'
import Ws from '../../providers/Ws';
import { FormControl, InputLabel, Select, Input, MenuItem, Button, Grid, Avatar } from '@material-ui/core';

export default class ConcediuAngajat extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            listDaysOfWeek:
                [
                    {
                        id: 1,
                        name: 'L',
                        date: '',
                        selectedDay: false,
                        color: 'rgb(171 171 171)',
                        backgroundColor: 'rgb(250 250 250)',
                        pontajList: []
                    },
                    {
                        id: 2,
                        name: 'M',
                        date: '',
                        selectedDay: false,
                        color: 'rgb(171 171 171)',
                        backgroundColor: 'rgb(250 250 250)',
                        pontajList: []
                    },
                    {
                        id: 3,
                        name: 'M',
                        date: '',
                        selectedDay: false,
                        color: 'rgb(171 171 171)',
                        backgroundColor: 'rgb(250 250 250)',
                        pontajList: []
                    },
                    {
                        id: 4,
                        name: 'J',
                        date: '',
                        selectedDay: false,
                        color: 'rgb(171 171 171)',
                        backgroundColor: 'rgb(250 250 250)',
                        pontajList: []
                    },
                    {
                        id: 5,
                        name: 'V',
                        date: '',
                        selectedDay: false,
                        color: 'rgb(171 171 171)',
                        backgroundColor: 'rgb(250 250 250)',
                        pontajList: []
                    },
                    {
                        id: 6,
                        name: 'S',
                        date: '',
                        selectedDay: false,
                        color: 'white',
                        backgroundColor: 'rgba(252	93	98)',
                        pontajList: []
                    },
                    {
                        id: 7,
                        name: 'D',
                        date: '',
                        selectedDay: false,
                        color: 'white',
                        backgroundColor: 'rgba(252	93	98)',
                        pontajList: []
                    }

                ],


        }
    }

    componentDidMount() {


    }

    u = new Utils()

    numeLuna = (l) => {

        // console.log('l :', l);
        let rez = ''

        switch (l) {
            case 1: rez = this.dictionary.luni.ianuarie; break;
            case 2: rez = this.dictionary.luni.februarie; break;
            case 3: rez = this.dictionary.luni.martie; break;
            case 4: rez = this.dictionary.luni.aprilie; break;
            case 5: rez = this.dictionary.luni.mai; break;
            case 6: rez = this.dictionary.luni.iunie; break;
            case 7: rez = this.dictionary.luni.iulie; break;
            case 8: rez = this.dictionary.luni.august; break;
            case 9: rez = this.dictionary.luni.septembrie; break;
            case 10: rez = this.dictionary.luni.octombrie; break;
            case 11: rez = this.dictionary.luni.noiembrie; break;
            case 12: rez = this.dictionary.luni.decembrie; break;

        }

        return rez
    }







    getProgramatorInfo = () => {




        let angajati = [...this.props.angajati]
        let pontaje = [...this.props.pontajeAll]

        // console.log('pontaje all :', pontaje);



        let u = new Utils();

        let nrOfDaysInMonth = u.getDaysInMonth(this.props.anul, this.props.luna)

        let dataSelected = new Date().setFullYear(this.props.anul)
        dataSelected = new Date(dataSelected).setMonth(this.props.luna - 1)

        // console.warn('nrOfDaysInMonth :', nrOfDaysInMonth);

        let tableHead = []

        let tH = []

        let table = []

        let tBody = []


        //console.log('angajati :', angajati);


        for (let i = -1, n = angajati.length; i < n; i++) {
            let tr = []
            for (let j = 0; j < nrOfDaysInMonth; j++) {
                let date = new Date(dataSelected).setDate(j)
                console.log('this.state.listDaysOfWeek[new Date(date).getDay()] :>> ', this.state.listDaysOfWeek[new Date(date).getDay()]);
                if (i === -1) {

                    tH.push(<th style={{ backgroundColor: this.state.listDaysOfWeek[new Date(date).getDay()].backgroundColor, color: this.state.listDaysOfWeek[new Date(date).getDay()].color, textAlign: 'center' }} key={`th${j}`}>{this.state.listDaysOfWeek[new Date(date).getDay()].name} </th>)

                } else {
                    let dataCalendar = u.transformDataForSql(new Date(dataSelected).setDate(j + 1));

                    let filterPontaje = pontaje.filter(p => p.id_angajat === angajati[i].id)



                    //    console.log('dataCalendar :', dataCalendar);

                    let idx = filterPontaje.findIndex(p => u.ParseDataFromSql(p.cand_inceput_dataC) <= dataCalendar && u.ParseDataFromSql(p.cand_sfarsit_dataC) >= dataCalendar)

                    let filterPrezenta = filterPontaje.filter(p => p.prezenta > 0)
                    //       console.log('filterPontaje :', filterPontaje);

                    console.log('idx :>> ', idx);

                    if (idx === -1) {

                        let idx2 = filterPrezenta.findIndex(p => u.ParseDataFromSql(p.la_data) === dataCalendar)
                        if (idx2 !== -1) {

                            tr.push(<td style={{ backgroundColor: this.state.listDaysOfWeek[new Date(date).getDay()].id < 6 ? 'rgb(250 250 250)' : 'rgb(231 231 231)', color: 'rgb(171 171 171)', textAlign: 'center', cursor: 'pointer' }} key={`td${angajati[i].id}${j}`}>
                                <span>{j + 1}</span>
                                <div >
                                    
                                        <span><div style={{
                                            backgroundColor:this.state.listDaysOfWeek[new Date(date).getDay()].id < 6 ?( filterPrezenta[idx2].prezenta === 1 ? 'rgb(135	226	167)' : 'rgb(227, 51, 59)') : 'transparent',
                                            width: filterPrezenta[idx2].prezenta === 0 ? 10 : 5,
                                            height: filterPrezenta[idx2].prezenta === 0 ? 10 : 5,
                                            borderRadius: '50%',
                                            margin: 'auto',
                                            marginTop: 5
                                        }}></div></span>
                                    

                                </div>

                            </td>)
                        } else {
                            tr.push(<td style={{ backgroundColor: this.state.listDaysOfWeek[new Date(date).getDay()].id < 6 ? 'rgb(250 250 250)' : 'rgb(231 231 231)', color: 'rgb(171 171 171)', textAlign: 'center', cursor: 'pointer' }} key={`td${angajati[i].id}${j}`}>
                                <span>{j + 1}</span>
                                <div >
                                 
                                        <span><div style={{
                                            backgroundColor:this.state.listDaysOfWeek[new Date(date).getDay()].id < 6 ? 'rgb(135	226	167)' : 'transparent',
                                            width: 5,
                                            height: 5,
                                            borderRadius: '50%',
                                            margin: 'auto',
                                            marginTop: 5
                                        }}></div></span>
                                    
                                </div>


                            </td>)

                        }



                    } else {
                        let tipConcedii = u.tipConcedii

                        let idxC = tipConcedii.findIndex(t => t.id === filterPontaje[idx].tip_concediu)
                        if (idxC !== -1) {

                            tr.push(<td onClick={() => { this.props.editConcediu(filterPontaje[idx], tipConcedii[idxC]) }} style={{ backgroundColor: this.state.listDaysOfWeek[new Date(date).getDay()].id < 6 ? 'rgb(250 250 250)' : 'rgb(231 231 231)', color: 'rgb(171 171 171)', textAlign: 'center', cursor: 'pointer' }} key={`td${angajati[i].id}${j}`}>
                                <span>{j + 1}</span>
                                <div style={{minHeight:27}}>
                                    
                                        <span><div style={{ backgroundColor:this.state.listDaysOfWeek[new Date(date).getDay()].id < 6 ? tipConcedii[idxC].bkColor : 'transparent', color: tipConcedii[idxC].color, width: 10, height: 10, borderRadius: '50%' }}></div></span>
                                    

                                </div>


                            </td>)
                        } else {

                            tr.push(<td style={{ backgroundColor: this.state.listDaysOfWeek[new Date(date).getDay()].id < 6 ? 'rgb(250 250 250)' : 'rgb(231 231 231)', color: '#72816e', textAlign: 'center', cursor: 'pointer' }} key={`td${angajati[i].id}${j}`}>
                                <span>{j + 1}</span>
                                <div >
                                
                                        <span><div style={{ backgroundColor: this.state.listDaysOfWeek[new Date(date).getDay()].id < 6 ? tipConcedii[idxC].bkColor : 'trasnparent', color: tipConcedii[idxC].color, width: 10, height: 10, borderRadius: '50%' }}></div></span>
                                    
                                </div>

                            </td>)
                        }

                    }





                    // if (idx !== -1) {

                    //     console.log('filterPontaje :', filterPontaje[idx]);

                    //     if (filterPontaje[idx].prezenta > 0) {

                    //         tr.push(<td key={`td${angajati[i].id}${j}`} style={{ backgroundColor: '#0da20dbd', color: 'white', textAlign: 'center', border: '1px solid #d8d4d4' }}>{j + 1}</td>)
                    //     } else {
                    //         tr.push(<td key={`td${angajati[i].id}${j}`} style={{ backgroundColor: 'orange', color: 'white', textAlign: 'center', border: '1px solid #d8d4d4' }}>{j + 1}</td>)
                    //     }
                    // } else {
                    //     tr.push(<td key={`td${angajati[i].id}${j}`} style={{ backgroundColor: (new Date(dataCalendar).getDay() === 6 || new Date(dataCalendar).getDay() === 0) ? 'rgba(202, 202, 202, 0.63)' : '#d8101080', color: 'white', textAlign: 'center', border: '1px solid #d8d4d4' }}>{j + 1}</td>)
                    // }
                }
            }

            if (i !== -1) {
                tr = (<tr onClick={() => { this.props.openDetaliiAngajat(angajati[i]) }} key={`tr${angajati[i].id}`}>
                    <td style={{ padding: '5px 0 5px 0 ' }} colSpan={5} >

                        <Grid container>

                            <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                {
                                    u.poza &&
                                    <div
                                        className='pm-angajati-picture'

                                        style={{ backgroundImage: `url('${angajati[i].poza ? (new Ws().adresaMedia + '/Angajati/' + angajati[i].poza) : avatar}')`, width: 36, height: 36, padding: 5 }}>

                                    </div>
                                }
                                {!u.poza &&

                                    <Avatar
                                        className='pm-angajati-picture'
                                        style={{ display: 'inline-block', textAlign: 'center', height: 24, width: 24, backgroundColor: new Utils().culoriUtilizatori(angajati[i].id), padding: 5, cursor: 'pointer' }}>
                                        {/* <i style={{ verticalAlign: '-webkit-baseline-middle', cursor: 'pointer' }} className='material-icons'>person</i> */}
                                        <span style={{ display: 'block' }}>{this.numeAvatar(angajati[i].nume)} </span>
                                    </Avatar>
                                    // <Avatar onClick={this.props.userClick} style={{ display: 'inline-flex' }} className='pm-avatar'> {this.getLitereAvatar(u.nume + ' ')} </Avatar>
                                }
                            </Grid>

                            <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>
                                <span style={{ fontWeight: 700, fontSize: 14 }}>    {angajati[i].nume}</span><br />
                                <span style={{
                                    fontSize: 12,
                                    color: '#9a9a9a'
                                }}>{angajati[i].functie}</span>
                            </Grid>

                        </Grid>

                        {/* <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div
                                // onClick={()=>{this.selectFile(`file${s.id}`)}}
                                onClick={() => { this.props.openDetaliiAngajat(angajati[i]) }}
                                className='pm-angajati-picture'
                                style={{ backgroundImage: `url('${angajati[i].poza ? (new Ws().adresaMedia + '/Angajati/' + angajati[i].poza) : avatar}')` }}>

                            </div>



                            <span
                                style={{
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden',
                                    width: 130,
                                    display: 'inline-block',
                                    whiteSpace: 'nowrap'

                                }}
                                className='pm-title'>
                                {angajati[i].nume}
                            </span>

                        </div> */}
                    </td>
                    {tr}
                </tr>)

                let trSpacer = (
                    <tr style={{ height: 10 }}>

                    </tr>
                )

                tBody.push(tr)

                tBody.push(trSpacer)

            }





        }



        tableHead = (<thead>
            <tr >
                <th style={{ position: 'sticky', top: 0, zIndex: 1 }} colSpan={5}>
                    <div style={{ position: 'relative' }}>
                        <select
                            id='departament'
                            style={{ width: '90%', paddingTop: 9, paddingBottom: 9 }}
                            className='add-project-input'
                            type="text"
                            margin="normal"
                            name='tva'
                            disabled={this.props.departamentDisabled !== 1 ? true : false}
                            value={this.props.departament || ""}
                            onChange={(ev) => { this.props.changeDepartament(ev) }}
                            placeholder={this.dictionary.pontaje.departamentCautaLucrator}
                        >

                            <option value={-1}>{this.dictionary.pontaje.toate}</option>
                            {this.props.departamente.map((s, idx) => {
                                return (
                                    <option key={idx} value={s.id}>{s.nume}</option>
                                )
                            })}
                        </select>
                        {/* <label className='inputLabelPM' htmlFor='tipCost'>{this.dictionary.evaluari.selecteaza}</label> */}
                    </div>

                </th>
                {tH}
            </tr>
            <tr style={{ height: 10 }}>

            </tr>
        </thead>)



        table = (
            <div className='scrolltable' style={{ marginBottom: 50 }}>

                <table style={{
                    width: '100%',
                    minWidth: 1200,
                    maxWidth: 1300,
                    margin: '20px auto',
                    marginBottom: 0,
                    tableLayout: 'fixed',
                    borderCollapse: 'collapse',
                    backgroundColor: 'white',
                    position: 'relative',
                    fontSize: 12
                }}>
                    {tableHead}</table>
                <div className='body'>

                    <table style={{
                        width: '100%',
                        minWidth: 1200,
                        maxWidth: 1300,
                        margin: '0 auto',
                        tableLayout: 'fixed',
                        borderCollapse: 'collapse',
                        backgroundColor: 'white',
                        position: 'relative',
                        fontSize: 12
                    }}>
                        <tbody>{tBody}</tbody>
                    </table>



                </div>
            </div>
        )

        return table

    }



    numeAvatar = (nume) => {

        if(nume){
            let n = nume.split(' ')

            // console.log('n :>> ', n);
    
            let firstLetters = ''
    
            if (n[0]) {
    
                firstLetters += n[0].substring(0, 1)
    
            }
            if (n[1]) {
                firstLetters += n[1].substring(0, 1)
            }
    
            firstLetters = firstLetters.toUpperCase()
    
            return firstLetters
        }else{
            return 'NA'
        }
        

    }
    render() {
        return (

            <Grid container>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40, maxHeight: 600, overflow: 'scroll' }}>



                        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                            <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} > {this.dictionary.pontaje.calendarPontaj}</h5>
                        </Grid>

                        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                            <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'center', fontWeight: 400 }} >
                                <i className='material-icons' style={{ verticalAlign: 'middle', fontSize: 20 }}>today</i>
                                {this.u.dataFullPlusDay(new Date())}</h5>
                        </Grid>

                        <Grid style={{ textAlign: 'right' }} item xs={4} sm={4} md={4} lg={4} xl={4}>
                            <div style={{ marginTop: 20, textAlign: 'right' }} className='monthcalendar-header'>
                                <i onClick={this.props.minusLuna} className='material-icons' style={{ verticalAlign: 'sub', cursor: 'pointer', fontSize: 20 }}>keyboard_arrow_left</i>
                                <span style={{ fontSize: 16, verticalAlign: 'text-bottom', textTransform: 'uppercase' }} className='monthcalendar-title'>{this.numeLuna(this.props.luna)} {this.props.anul}</span>
                                <i onClick={this.props.plusLuna} className='material-icons' style={{ verticalAlign: 'sub', cursor: 'pointer', fontSize: 20 }}>keyboard_arrow_right</i>
                            </div>
                        </Grid>


                        <Grid style={{ textAlign: 'left', margin: '20px 0 20px 0' }} item xs={12} sm={12} md={12} lg={12} xl={12}>

                            {this.getProgramatorInfo()}
                        </Grid>


                    </Grid>
                </Grid>


                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40, }}>
                        <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                            <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} > {this.dictionary.pontaje.legenda}</h5>
                        </Grid>
                        <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
                            {this.props.tipConcedii &&
                                <div style={{ textAlign: 'left', marginTop: 10, width: '95%', margin: '0 auto', maxWidth: 1300 }}>
                                    <div style={{ display: 'inline-block', marginLeft: 10, marginTop: 10 }}>
                                        <div style={{ backgroundColor: 'rgb(135	226	167)', verticalAlign: 'middle', borderRadius: 10, height: 12, width: 12, marginRight: 5 }} className='pm-task-legend'></div>
                                        <span style={{ fontSize: 12 }}>Prezent</span>
                                    </div>

                                    {this.props.tipConcedii.map((c, idx) => {
                                        return (
                                            <div key={idx} style={{ display: 'inline-block', marginLeft: 10, marginTop: 10 }}>
                                                <div style={{ backgroundColor: c.bkColor, verticalAlign: 'middle', borderRadius: 10, height: 12, width: 12, marginRight: 5 }} className='pm-task-legend'></div>
                                                <span style={{ fontSize: 12 }}>{c.nume}</span>
                                            </div>
                                        )
                                    })}



                                </div>
                            }
                        </Grid>
                    </Grid>
                </Grid>

            </Grid>

        );
    }
}